'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var formSchema = require('@graffer-inc/form-schema');
var _$1 = require('lodash');
var OutsideClickHandler = require('@graffer-inc/react-outside-click-handler');
var formGenerator = require('@graffer-inc/form-generator');
var reactTextfit = require('@kyo_ago/react-textfit');
var _ = require('lodash-core');
var reactPdf = require('react-pdf');
var reactRnd = require('react-rnd');
var SimpleBar = require('simplebar-react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ___namespace$1 = /*#__PURE__*/_interopNamespace(_$1);
var OutsideClickHandler__default = /*#__PURE__*/_interopDefaultLegacy(OutsideClickHandler);
var ___namespace = /*#__PURE__*/_interopNamespace(_);
var SimpleBar__default = /*#__PURE__*/_interopDefaultLegacy(SimpleBar);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var LogEntity = /** @class */ (function () {
    function LogEntity(templateId, fieldId, status, occurredAt, elapsedTimeSeconds, numLetters, numSelectedChoices) {
        this.templateId = templateId;
        this.fieldId = fieldId;
        this.status = status;
        this.occurredAt = occurredAt;
        this.elapsedTimeSeconds = elapsedTimeSeconds;
        this.numLetters = numLetters;
        this.numSelectedChoices = numSelectedChoices;
    }
    LogEntity.prototype.setTemplateId = function (id) {
        this.templateId = id;
    };
    LogEntity.prototype.setElapsedTime = function (preLogEntity) {
        this.elapsedTimeSeconds = Math.floor((this.occurredAt.getTime() - preLogEntity.occurredAt.getTime()) / 1000);
    };
    LogEntity.prototype.isBlur = function () {
        return this.status === "BLUR";
    };
    return LogEntity;
}());

var LogFactory = /** @class */ (function () {
    function LogFactory() {
    }
    LogFactory.createLogEntityForFocus = function (formFieldId, value) {
        return new LogEntity(null, formFieldId, "FOCUS", new Date(), null, typeof value === "string" ? value.length : 0, null);
    };
    LogFactory.createLogEntityForBlur = function (formFieldId, value) {
        return new LogEntity(null, formFieldId, "BLUR", new Date(), null, typeof value === "string" ? value.length : 0, null);
    };
    LogFactory.createLogEntityForClicked = function (formFieldId, numSelectedChoices) {
        return new LogEntity(null, formFieldId, "CLICKED", new Date(), null, null, numSelectedChoices);
    };
    return LogFactory;
}());

var FocusInput = /** @class */ (function () {
    function FocusInput(formFieldId, areaIndex) {
        this.id = formFieldId + "_" + areaIndex.toString();
    }
    Object.defineProperty(FocusInput.prototype, "formFieldId", {
        get: function () {
            return this.id.substr(0, this.id.lastIndexOf("_"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FocusInput.prototype, "areaIndex", {
        get: function () {
            return parseInt(this.id.substr(this.id.lastIndexOf("_") + 1, this.id.length));
        },
        enumerable: false,
        configurable: true
    });
    FocusInput.prototype.isEqual = function (input) {
        return (this.formFieldId === input.formFieldId &&
            this.areaIndex === input.areaIndex);
    };
    return FocusInput;
}());

var CustomizedFileInput = function (_a) {
    var config = _a.config;
    return (React__namespace.createElement("input", { type: "text", className: "input", name: config.formFieldId, value: "ファイル添付は未実装です", readOnly: true, disabled: true }));
};

var PDFFormViewerInputRegistry = /** @class */ (function () {
    function PDFFormViewerInputRegistry() {
    }
    PDFFormViewerInputRegistry.prototype.get = function (elem, repeatable) {
        if (formSchema.isMyNumberInputElement(elem)) {
            return formGenerator.DefaultInputTemplateRegistry.map["text"];
        }
        if (formSchema.isFileInputElement(elem)) {
            //possibly throw new Error. Fix after spec is defined
            return CustomizedFileInput;
        }
        return formGenerator.DefaultInputTemplateRegistry.get(elem, repeatable);
    };
    return PDFFormViewerInputRegistry;
}());

var OverlayFormWrapper = function (_a) {
    var children = _a.children, closeInputField = _a.closeInputField;
    var submitHandler = function (e) {
        e.preventDefault();
        closeInputField();
    };
    var handleKeyBoardEvent = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (e.keyCode === 27) {
                closeInputField();
            }
            return [2 /*return*/];
        });
    }); };
    return (React__namespace.createElement("form", { onSubmit: function (e) { return submitHandler(e); }, className: "is-relative", onKeyUp: handleKeyBoardEvent },
        children,
        React__namespace.createElement("div", { style: {
                height: 0,
                opacity: 0,
                margin: 0,
                padding: 0,
                visibility: "collapse",
            } },
            React__namespace.createElement("button", { type: "submit", "aria-label": "\u7DE8\u96C6\u5B8C\u4E86" }))));
};
var OverlayInput = function (props) {
    var focusInput = props.focusInput, renderInputs = props.renderInputs;
    var inputRegistry = new PDFFormViewerInputRegistry();
    var refs = React.useRef(Array(renderInputs.length).fill(null));
    React.useEffect(function () {
        var targetRef = refs.current[renderInputs.indexOf(focusInput)];
        if (targetRef) {
            targetRef.focus();
        }
    }, [renderInputs, focusInput]);
    return (React__namespace.createElement(React__namespace.Fragment, null, renderInputs.inputs.map(function (input, index) { return (React__namespace.createElement(InputWrapper, __assign({ key: input.areaIndex }, props, { index: index, refs: refs, input: input, inputRegistry: inputRegistry }))); })));
};
var InputWrapper = function (props) {
    var focusInput = props.focusInput, setFocusInput = props.setFocusInput, actionOnPDFForLog = props.actionOnPDFForLog, actionOnPDF = props.actionOnPDF, closeInputField = props.closeInputField, refs = props.refs, input = props.input, index = props.index, inputRegistry = props.inputRegistry;
    var isNotActive = !focusInput.isEqual(input);
    var area = input.pdfAdapterRule.areas[input.areaIndex];
    var innerHiddenStyle = {
        height: 0,
        opacity: 0,
        margin: 0,
        padding: 0,
        top: area.position.y,
        left: area.position.x,
    };
    var minWidth = 150;
    var minHeight = 36;
    var width = Math.max(area.size.width * 1.5, minWidth);
    var height = Math.max(area.size.height, minHeight);
    var activeStyle = {
        top: area.position.y + area.size.height,
        left: area.position.x - (width - area.size.width) / 2,
        width: width,
        minWidth: minWidth,
        height: height,
        minHeight: minHeight,
    };
    var Input = inputRegistry.get(input);
    var _a = React.useState(input.value), value = _a[0], setValue = _a[1];
    var onFocus = function () {
        setFocusInput(new FocusInput(input.formFieldId, input.areaIndex));
        actionOnPDFForLog(LogFactory.createLogEntityForFocus(input.formFieldId, input.value));
    };
    var onBlur = function () {
        actionOnPDFForLog(LogFactory.createLogEntityForBlur(input.formFieldId, input.value));
    };
    var onChange = function (e) {
        setValue(e.target.value);
        actionOnPDF(input.formFieldId, e.target.value);
    };
    var ref = React.useRef(refs.current[index]);
    return (React__namespace.createElement(OutsideClickHandler__default["default"], { disabled: isNotActive, onOutsideClick: function () { return closeInputField(); }, key: index },
        React__namespace.createElement("div", { className: "control", style: isNotActive
                ? __assign(__assign({}, innerHiddenStyle), { pointerEvents: "none" }) : activeStyle },
            React__namespace.createElement(Input, __assign({ refObj: ref, config: input, tabIndex: index + 1, value: value, setValue: function (v) {
                    setValue(v);
                    actionOnPDF(input.formFieldId, v);
                }, onFocus: onFocus, onBlur: onBlur, onChange: onChange }, NoOpsProps)))));
};
var NoOpsProps = {
    touched: false,
    error: undefined,
};

var EditWrapper = function (props) {
    var style = props.style, onClick = props.onClick, size = props.size, position = props.position;
    return (React__namespace.createElement("div", { id: "obj_".concat(props.elem.formFieldId), style: __assign(__assign({}, style), { position: "absolute", top: position.y, left: position.x, width: size.width, height: size.height }), onClick: onClick }, props.renderChild && props.renderChild(props)));
};

var styles$3 = {
    borderStyle: {
        borderColor: "black",
        borderStyle: "groove",
        borderWidth: "0.2px",
    },
    baseStyle: {
        backgroundColor: "rgba(0, 0, 255, 0.1)",
    },
    requiredStyle: {
        backgroundColor: "rgba(240, 52, 52, 0.1)",
    },
    focusStyle: {
        borderColor: "red",
        borderStyle: "solid",
        borderWidth: "1px",
    },
};
var getStyle = function (isFocused, isRequired) {
    return __assign(__assign(__assign({}, styles$3.borderStyle), (isRequired ? styles$3.requiredStyle : styles$3.baseStyle)), (isFocused ? styles$3.focusStyle : null));
};

/**
 * Provide text alignment style base on `align` config
 * @param align 'top' | 'center' | 'bottom'
 */
function verticalAlign(align) {
    switch (align) {
        case "top":
            return {};
        case "center":
            return {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            };
        case "bottom":
            // TODO: Fix
            return {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            };
        default:
            return {};
    }
}

var TextBox$2 = React__namespace.memo(function (props) {
    var valign = props.valign, align = props.align, size = props.size;
    var openInputField = props.openInputField;
    var renderValue = props.renderValue, isFocused = props.isFocused, isRequired = props.isRequired;
    var colorStyle = getStyle(!!isFocused, isRequired);
    var textFitStyle = __assign({ width: "100%", height: "100%", textAlign: align }, (valign === "bottom" ? { alignSelf: "flex-end" } : null));
    var wrapperStyle = __assign(__assign({}, verticalAlign(valign)), colorStyle);
    return (React__namespace.createElement(EditWrapper, __assign({}, props, { style: wrapperStyle, enableResizable: false, onClick: function () { return openInputField && openInputField(); }, renderChild: function (props) {
            return (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(reactTextfit.Textfit, { style: textFitStyle, width: size.width, height: size.height, min: 1, max: 12, mode: "multi", autoResize: false }, renderValue)));
        } })));
});

var Check$2 = React__namespace.memo(function (props) {
    var value = props.value, isMultipleSelect = props.isMultipleSelect;
    var actionOnPDF = props.actionOnPDF, emitLog = props.emitLog;
    var isFocused = props.isFocused, isSelected = props.isSelected, renderValue = props.renderValue, isRequired = props.isRequired;
    var colorStyle = getStyle(!!isFocused, isRequired);
    var wrapperStyle = __assign(__assign({ textAlign: "center", fontSize: "8px" }, colorStyle), (!isFocused
        ? {
            borderStyle: "none",
            borderWidth: "none",
        }
        : {}));
    if (renderValue) {
        if (isMultipleSelect && !Array.isArray(renderValue)) {
            throw new Error("".concat(props.elem.formFieldId, " is multiple select, but not array render value passed ").concat(renderValue));
        }
        if (!isMultipleSelect && !___namespace.isString(renderValue)) {
            throw new Error("".concat(props.elem.formFieldId, " is multiple select, but not string value passed ").concat(renderValue));
        }
    }
    var onClick = function () {
        if (!actionOnPDF) {
            return;
        }
        if (isMultipleSelect) {
            var returnValue = void 0;
            if (isSelected) {
                // @ts-ignore
                returnValue = renderValue.filter(function (v) { return v !== value; });
            }
            else {
                if (props.maxItems &&
                    // @ts-ignore
                    __spreadArray([], (renderValue || []), true).length === props.maxItems) {
                    alert("\u6700\u5927 ".concat(props.maxItems, "\u500B\u307E\u3067\u3057\u304B\u9078\u3079\u307E\u305B\u3093\u3002"));
                    emitLog(props.maxItems);
                    return;
                }
                // @ts-ignore
                returnValue = __spreadArray(__spreadArray([], (renderValue || []), true), [value], false);
            }
            actionOnPDF(props.elem.formFieldId, returnValue);
            emitLog(returnValue.length);
        }
        else {
            actionOnPDF(props.elem.formFieldId, isSelected ? undefined : value);
            emitLog(isSelected ? 0 : 1);
        }
    };
    return (React__namespace.createElement(EditWrapper, __assign({ onClick: onClick }, props, { style: wrapperStyle, renderChild: function () {
            return isSelected ? React__namespace.createElement(React__namespace.Fragment, null, "\u2714\uFE0E") : null;
        } })));
});

// Maybe we should separate multiple and single select into two objects.
var Ellipse$2 = React__namespace.memo(function (props) {
    var value = props.value, isMultipleSelect = props.isMultipleSelect;
    var actionOnPDF = props.actionOnPDF, emitLog = props.emitLog;
    var isFocused = props.isFocused, isSelected = props.isSelected, renderValue = props.renderValue, isRequired = props.isRequired;
    var colorStyle = getStyle(!!isFocused, isRequired);
    var wrapperStyle = __assign(__assign({ textAlign: "center", borderRadius: "50%" }, colorStyle), (!isSelected
        ? {
            borderStyle: "none",
            borderWidth: "none",
        }
        : {}));
    if (renderValue) {
        if (isMultipleSelect && !Array.isArray(renderValue)) {
            throw new Error("".concat(props.elem.formFieldId, " is multiple select, but not array render value passed ").concat(renderValue));
        }
        if (!isMultipleSelect && !___namespace.isString(renderValue)) {
            throw new Error("".concat(props.elem.formFieldId, " is multiple select, but not string value passed ").concat(renderValue));
        }
    }
    var onClickForEdit = function () {
        if (!actionOnPDF) {
            return;
        }
        if (isMultipleSelect) {
            var returnValue = void 0;
            if (isSelected) {
                // @ts-ignore
                returnValue = (renderValue || []).filter(function (v) { return v !== value; });
            }
            else {
                if (props.maxItems &&
                    // @ts-ignore
                    __spreadArray([], (renderValue || []), true).length === props.maxItems) {
                    alert("\u6700\u5927 ".concat(props.maxItems, "\u500B\u307E\u3067\u3057\u304B\u9078\u3079\u307E\u305B\u3093\u3002"));
                    emitLog(props.maxItems);
                    return;
                }
                // @ts-ignore
                returnValue = __spreadArray(__spreadArray([], (renderValue || []), true), [value], false);
            }
            actionOnPDF(props.elem.formFieldId, returnValue);
            emitLog(returnValue.length);
        }
        else {
            actionOnPDF(props.elem.formFieldId, isSelected ? undefined : value);
            emitLog(isSelected ? 0 : 1);
        }
    };
    return (React__namespace.createElement(EditWrapper, __assign({ onClick: onClickForEdit, enableResizable: false }, props, { style: wrapperStyle })));
});

var TextCellOneChar = function (props) {
    var size = props.size, renderValue = props.renderValue;
    var textFitStyle = {
        width: "100%",
        height: "100%",
        textAlign: "center",
    };
    var wrapperStyle = __assign({}, verticalAlign("center"));
    var position = props.position;
    var initialSize = {
        x: position.x,
        y: position.y,
        width: size.width,
        height: size.height,
    };
    return (React__namespace.createElement("span", { style: __assign(__assign({}, wrapperStyle), { position: "absolute", top: initialSize.y, left: initialSize.x, width: size.width, height: size.height }) },
        React__namespace.createElement(reactTextfit.Textfit, { style: textFitStyle, width: size.width, height: size.height, min: 1, max: 12, mode: "multi", autoResize: false }, renderValue)));
};
var TextCell$2 = React__namespace.memo(function (props) {
    var size = props.size, _a = props.cellSize, horizontal = _a.horizontal, vertical = _a.vertical, justified = props.justified;
    var renderValue = props.renderValue, isFocused = props.isFocused, isRequired = props.isRequired;
    var openInputField = props.openInputField;
    var colorStyle = getStyle(!!isFocused, isRequired);
    var wrapperStyle = __assign({}, colorStyle);
    var cellWidth = size.width / vertical;
    var cellHeight = size.height / horizontal;
    var CharComponents = renderValue &&
        // TODO: Add test for surrogate pair handling.
        Array.from(renderValue).map(function (s, index) {
            var hpos = index % vertical;
            var vpos = Math.floor(index / vertical) + justified === "right" &&
                hpos === renderValue.length / vertical
                ? vertical - (renderValue.length % vertical)
                : 0;
            if (index >= vertical * horizontal) {
                // if input value larger than cellSize, the char should not be displayed.
                return null;
            }
            return (React__namespace.createElement(TextCellOneChar, __assign({}, props, { key: index, renderValue: s, position: {
                    x: hpos * cellWidth,
                    y: vpos * cellHeight,
                }, size: {
                    width: cellWidth,
                    height: cellHeight,
                } })));
        });
    return (React__namespace.createElement(EditWrapper, __assign({}, props, { onClick: function () { return openInputField && openInputField(); }, enableResizable: false, style: wrapperStyle, renderChild: function () {
            return React__namespace.createElement("div", null, CharComponents);
        } })));
});

/**
 * PDF上にレンダリングするPreview用オブジェクトの作成。
 * 初期化後に変更されえない値と、変更されうる値（documentの値、focusされているFieldのID)を分けて、渡すようにして、不必要な再描画を抑える
 * * これを入れておかないないと、Object数が100を超えるような複雑な帳票の時に、入力が著しくおそくなる。
 */
var preparePDFOverlayObjects$2 = function (props) {
    return function (formData, focusFieldIDs, focusFormFieldId, actionOnPDF, actionOnPDFForLog, currentPageNumber, keyRefreshCount) {
        return formSchema.flatMap(props.allInputs, function (elem) {
            var pdfAdapter = elem.pdfAdapterRule;
            if (!pdfAdapter) {
                return [null];
            }
            var isFocused = elem.formFieldId === focusFormFieldId ||
                focusFieldIDs.indexOf(elem.id) > -1;
            var maxItems = formSchema.isCheckboxesElement(elem) ? elem.maxItems : undefined;
            var minItems = formSchema.isCheckboxesElement(elem) ? elem.minItems : undefined;
            var repeatablePair = elem.isExpanded()
                ? {
                    element: elem.parent.repeatable,
                    indexes: {
                        elemIndex: elem.parent.elemIndex,
                        unitIndex: elem.parent.repeatable.baseUnit.findIndex(function (e) { return e.id === elem.id; }),
                    },
                }
                : undefined;
            var emitLog = function (numSelectedChoices) {
                actionOnPDFForLog(LogFactory.createLogEntityForClicked(elem.id, numSelectedChoices));
            };
            switch (pdfAdapter.type) {
                case "text":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(TextBox$2, { elem: elem, key: key, isFocused: isFocused, areaIndex: index, renderValue: formSchema.FormHelper.getValue(formData, elem.formFieldId), position: a.position, size: a.size, pageNumber: a.pageNumber, valign: a.valign, align: a.align, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, openInputField: function () {
                                return props.setFocusInput(new FocusInput(elem.formFieldId, index));
                            }, actionOnPDF: actionOnPDF, actionOnPDFForLog: actionOnPDFForLog, isRequired: elem.required }));
                    });
                case "text_cell":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(TextCell$2, { elem: elem, key: key, isFocused: isFocused, areaIndex: index, renderValue: formSchema.FormHelper.getValue(formData, elem.formFieldId), position: a.position, size: a.size, pageNumber: a.pageNumber, cellSize: pdfAdapter.cellSize, justified: pdfAdapter.justified, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, openInputField: function () {
                                return props.setFocusInput(new FocusInput(elem.formFieldId, index));
                            }, actionOnPDF: actionOnPDF, actionOnPDFForLog: actionOnPDFForLog, isRequired: elem.required }));
                    });
                case "check":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var renderValue = ___namespace.get(formData, elem.id);
                        var isSelected = Array.isArray(renderValue)
                            ? renderValue.indexOf(a.value) > -1
                            : renderValue === a.value;
                        var isMultipleSelect = formSchema.isCheckboxesElement(elem);
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(Check$2, { elem: elem, key: key, isMultipleSelect: isMultipleSelect, isFocused: isFocused, isSelected: isSelected, areaIndex: index, renderValue: renderValue, maxItems: maxItems, minItems: minItems, value: a.value, position: a.position, size: a.size, pageNumber: a.pageNumber, emitLog: function (numSelectedChoices) {
                                return emitLog(numSelectedChoices);
                            }, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, openInputField: function () {
                                return props.setFocusInput(new FocusInput(elem.formFieldId, index));
                            }, actionOnPDF: actionOnPDF, actionOnPDFForLog: actionOnPDFForLog, isRequired: elem.required }));
                    });
                case "ellipse":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        var renderValue = ___namespace.get(formData, elem.id);
                        var isSelected = Array.isArray(renderValue)
                            ? renderValue.indexOf(a.value) > -1
                            : renderValue === a.value;
                        var isMultipleSelect = formSchema.isCheckboxesElement(elem);
                        return (React__namespace.createElement(Ellipse$2, { elem: elem, key: key, isFocused: isFocused, isSelected: isSelected, isMultipleSelect: isMultipleSelect, areaIndex: index, renderValue: renderValue, maxItems: maxItems, minItems: minItems, value: a.value, position: a.position, size: a.size, pageNumber: a.pageNumber, emitLog: function (numSelectedChoices) {
                                return emitLog(numSelectedChoices);
                            }, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, openInputField: function () {
                                return props.setFocusInput(new FocusInput(elem.formFieldId, index));
                            }, actionOnPDF: actionOnPDF, actionOnPDFForLog: actionOnPDFForLog, isRequired: elem.required }));
                    });
            }
        });
    };
};

var PDFOverlayLayer = /** @class */ (function (_super) {
    __extends(PDFOverlayLayer, _super);
    function PDFOverlayLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFOverlayLayer.prototype.render = function () {
        var children = this.props.children;
        var style = {
            position: "absolute",
            top: 0,
            left: 0,
        };
        return (React__namespace.createElement("div", { key: 0, style: style }, children));
    };
    return PDFOverlayLayer;
}(React__namespace.Component));

var PDFDocumentForRenderingPreview = function (_a) {
    var file = _a.file, options = _a.options, pageNumber = _a.pageNumber, renderMode = _a.renderMode, errorMessage = _a.errorMessage, onLoadSuccess = _a.onLoadSuccess, onLoadError = _a.onLoadError, _b = _a.autoZoom, autoZoom = _b === void 0 ? false : _b, children = _a.children;
    // PDFの倍率変更（画面幅いっぱいに拡大する）
    var autoZoomRef = React.useCallback(function (pageNode) {
        if (!pageNode) {
            return;
        }
        // 適応済みの場合無視する
        // 非標準の属性ではあるが、transform: scale()が挙動が変わるため一旦現状のまま維持する
        // zoom - CSS: カスケーディングスタイルシート | MDN https://developer.mozilla.org/ja/docs/Web/CSS/zoom
        if (pageNode.style.zoom) {
            return;
        }
        var content = pageNode.firstElementChild;
        if (!content) {
            return;
        }
        var ratio = pageNode.clientWidth / content.clientWidth;
        // 同じ倍率なので無視する
        if (ratio === 1) {
            return;
        }
        pageNode.style.zoom = "".concat(ratio * 100, "%");
    }, [file]);
    var pageRef = autoZoom ? autoZoomRef : function () { };
    return (React__namespace.createElement(reactPdf.Document, { file: file, error: errorMessage, renderMode: renderMode, 
        // security issue: isEvalSupported is not defined
        // add isEvalSupported to options with false value
        options: __assign(__assign({}, options), { isEvalSupported: false }), onLoadSuccess: onLoadSuccess, onLoadError: onLoadError },
        React__namespace.createElement(reactPdf.Page, { key: pageNumber, renderMode: renderMode, pageNumber: pageNumber, inputRef: pageRef },
            React__namespace.createElement(PDFOverlayLayer, { key: pageNumber }, children))));
};

/*
 * pdfAdapterRuleで複数areaがあることがあるため、実際に描画するinputの単位
 */
var RenderInputs = /** @class */ (function () {
    function RenderInputs(formData, elements, pageNumber) {
        this.inputs = elements.reduce(function (acc, cur) {
            var value = formSchema.FormHelper.getValue(formData, cur.formFieldId);
            return acc.concat(cur
                .pdfAdapterRule.areas.filter(function (area) { return area.pageNumber === pageNumber; })
                .map(function (_, areaIndex) {
                return Object.assign({}, cur, {
                    formFieldId: cur.formFieldId,
                    areaIndex: areaIndex,
                    value: value,
                    pdfAdapterRule: cur.pdfAdapterRule,
                });
            }));
        }, []);
        this.inputs.sort(renderInputsSort);
    }
    Object.defineProperty(RenderInputs.prototype, "length", {
        get: function () {
            return this.inputs.length;
        },
        enumerable: false,
        configurable: true
    });
    RenderInputs.prototype.indexOf = function (focusInput) {
        return this.inputs.findIndex(function (i) { return focusInput.isEqual(i); });
    };
    return RenderInputs;
}());
var renderInputsSort = function (a, b) {
    var aPos = a.pdfAdapterRule.areas[a.areaIndex].position;
    var bPos = b.pdfAdapterRule.areas[b.areaIndex].position;
    if (aPos.y < bPos.y || (aPos.y === bPos.y && aPos.x < bPos.x)) {
        return -1;
    }
    return 1;
};

var EditModePDFRenderingPreview = function (_a) {
    var file = _a.file, pageNumber = _a.pageNumber, keyRefreshCount = _a.keyRefreshCount, options = _a.options, formData = _a.formData, formDataForLog = _a.formDataForLog, formSchema$1 = _a.formSchema, _b = _a.focusFieldIds, focusFieldIds = _b === void 0 ? [] : _b, _c = _a.renderMode, renderMode = _c === void 0 ? "canvas" : _c, _d = _a.errorMessage, errorMessage = _d === void 0 ? "PDFの読み込みに失敗しました。再読み込みしてください。" : _d, _e = _a.onResize, onResize = _e === void 0 ? function () { } : _e, // noop,
    _f = _a.onDocumentChange, // noop,
    onDocumentChange = _f === void 0 ? function () { } : _f, _g = _a.onDocumentChangeForLog, onDocumentChangeForLog = _g === void 0 ? function () { } : _g, _h = _a.onDoubleClick, onDoubleClick = _h === void 0 ? function () { } : _h, // noop,
    _j = _a.onObjectEnter, // noop,
    onObjectEnter = _j === void 0 ? function () { } : _j, // noop,
    _k = _a.onObjectLeave, // noop,
    onObjectLeave = _k === void 0 ? function () { } : _k, // noop,
    _l = _a.onLoadSuccess, // noop,
    onLoadSuccess = _l === void 0 ? function () { } : _l, //noop
    _m = _a.onLoadError, //noop
    onLoadError = _m === void 0 ? function () { } : _m, //noop
    _o = _a.autoZoom, //noop
    autoZoom = _o === void 0 ? false : _o;
    var fs = formSchema.FormSchema.fromJSON(formSchema$1);
    var applyingRules = fs.filterApplyingRule(formData);
    var allInputs = React.useMemo(function () {
        return fs
            .flattenDeep()
            .map(function (i) { return i.applyRules(applyingRules); })
            .filter(function (j) {
            return formSchema.isInputClassElement(j) && !!j.pdfAdapterRule && !j.hidden;
        });
    }, [fs]);
    var _p = React.useState(), focusInput = _p[0], setFocusInput = _p[1];
    var closeInputField = function () {
        setFocusInput(undefined);
    };
    var actionOnPDF = function (formFieldId, newValue) {
        onDocumentChange(formSchema.FormHelper.setValue(formData, formFieldId, newValue));
    };
    var actionOnPDFForLog = function (newValue) {
        if (!formDataForLog || !onDocumentChangeForLog) {
            return;
        }
        // assume file is something like `/api/forms/v1/templates/${templateSchema.templateId}/file`
        newValue.setTemplateId(file.split("/")[5]);
        if (newValue.isBlur()) {
            newValue.setElapsedTime(formDataForLog[formDataForLog.length - 1]);
        }
        onDocumentChangeForLog(___namespace$1.concat(formDataForLog, newValue));
    };
    var PDFOverlayObject = React.useMemo(function () {
        return preparePDFOverlayObjects$2({
            allInputs: allInputs,
            setFocusInput: setFocusInput,
            onObjectLeave: onObjectLeave,
            onObjectEnter: onObjectEnter,
            onResize: onResize,
            onDoubleClick: onDoubleClick,
        });
    }, [allInputs]);
    return (React__namespace.createElement(PDFDocumentForRenderingPreview, { file: file, options: options, pageNumber: pageNumber, renderMode: renderMode, errorMessage: errorMessage, onLoadSuccess: onLoadSuccess, onLoadError: onLoadError, autoZoom: autoZoom },
        React__namespace.createElement(OverlayFormWrapper, { closeInputField: closeInputField },
            React__namespace.createElement(React__namespace.Fragment, null,
                PDFOverlayObject(formData, focusFieldIds, (focusInput === null || focusInput === void 0 ? void 0 : focusInput.formFieldId) || "", actionOnPDF, actionOnPDFForLog, pageNumber, keyRefreshCount || 0),
                focusInput && (React__namespace.createElement(OverlayInput, { formSchema: fs, focusInput: focusInput, actionOnPDF: actionOnPDF, actionOnPDFForLog: actionOnPDFForLog, setFocusInput: setFocusInput, closeInputField: closeInputField, renderInputs: new RenderInputs(formData, allInputs, pageNumber) }))))));
};

/**
 * Props to let `react-rnd` to disable resizing all direction.
 */
var disableResizingAll = {
    top: false,
    right: false,
    bottom: false,
    left: false,
    topRight: false,
    topLeft: false,
    bottomRight: false,
    bottomLeft: false,
};
/**
 * Props to let `react-rnd` to disable resizing all direction.
 */
var enableResizingAll = {
    top: true,
    right: true,
    bottom: true,
    left: true,
    topRight: true,
    topLeft: true,
    bottomRight: true,
    bottomLeft: true,
};

var BuilderWrapper$1 = function (_a) {
    var props = __rest(_a, []);
    var style = props.style, onClick = props.onClick;
    var areaIndex = props.areaIndex, pageNumber = props.pageNumber, size = props.size, position = props.position;
    var initialSize = {
        x: position.x,
        y: position.y,
        width: size.width,
        height: size.height,
    };
    var onResize = props.onResize, onDoubleClick = props.onDoubleClick, onObjectEnter = props.onObjectEnter, onObjectLeave = props.onObjectLeave, enableResizable = props.enableResizable, repeatablePair = props.repeatablePair, className = props.className;
    var resizing = enableResizable ? enableResizingAll : disableResizingAll;
    return (React__namespace.createElement(reactRnd.Rnd, { className: "has-text-left ".concat(className), default: initialSize, style: style, onResize: function (e, direction, ref, delta, position) {
            onResize({
                id: props.elem.id,
                elem: props.elem,
                areaIndex: areaIndex,
                area: {
                    pageNumber: pageNumber,
                    size: {
                        width: ref.offsetWidth,
                        height: ref.offsetHeight,
                    },
                    position: position,
                },
                repeatable: repeatablePair,
            });
        }, onDragStop: function (mouseEvent, node) {
            onResize({
                id: props.elem.id,
                elem: props.elem,
                area: {
                    pageNumber: pageNumber,
                    size: size,
                    position: { x: node.lastX, y: node.lastY },
                },
                areaIndex: areaIndex,
                repeatable: repeatablePair,
            });
        }, onClick: onClick, onDoubleClick: function () {
            return onDoubleClick({
                id: props.elem.id,
                elem: props.elem,
                areaIndex: areaIndex,
                repeatable: repeatablePair,
            });
        }, onMouseEnter: function () {
            return onObjectEnter({
                id: props.elem.id,
                elem: props.elem,
                areaIndex: areaIndex,
                repeatable: repeatablePair,
            });
        }, onMouseLeave: function () {
            return onObjectLeave({
                id: props.elem.id,
                elem: props.elem,
                areaIndex: areaIndex,
                repeatable: repeatablePair,
            });
        }, enableResizing: resizing, disableDragging: false }, props.renderChild && props.renderChild(props)));
};

var TextBox$1 = React__namespace.memo(function (props) {
    var wrapperStyle = {
        borderColor: "black",
        borderStyle: "solid",
        borderWidth: "1px",
        backgroundColor: "#F0F8FF",
    };
    return (React__namespace.createElement(BuilderWrapper$1, __assign({}, props, { style: wrapperStyle, enableResizable: true })));
});

var Check$1 = React__namespace.memo(function (props) {
    var wrapperStyle = {
        textAlign: "center",
        fontSize: "8px",
        backgroundColor: "rgba(0, 0, 255, 0.1)",
        borderStyle: "none",
        borderWidth: "none",
    };
    return (React__namespace.createElement(BuilderWrapper$1, __assign({}, props, { style: wrapperStyle, renderChild: function () {
            return React__namespace.createElement(React__namespace.Fragment, null, "\u2714\uFE0E");
        } })));
});

// Maybe we should separate multiple and single select into two objects.
var Ellipse$1 = React__namespace.memo(function (props) {
    var wrapperStyle = {
        textAlign: "center",
        borderRadius: "50%",
        borderStyle: "solid",
        borderColor: "red",
        borderWidth: "1px",
        backgroundColor: "rgba(0, 0, 255, 0.1)",
    };
    return (React__namespace.createElement(BuilderWrapper$1, __assign({ enableResizable: true }, props, { style: wrapperStyle })));
});

var TextCell$1 = React__namespace.memo(function (props) {
    var wrapperStyle = {
        borderColor: "black",
        borderStyle: "solid",
        borderWidth: "1px",
        backgroundColor: "#F0F8FF",
    };
    return (React__namespace.createElement(BuilderWrapper$1, __assign({}, props, { enableResizable: true, style: wrapperStyle })));
});

/**
 * PDF上にレンダリングするPreview用オブジェクトの作成。
 * 初期化後に変更されえない値と、変更されうる値（documentの値、focusされているFieldのID)を分けて、渡すようにして、不必要な再描画を抑える
 * * これを入れておかないないと、Object数が100を超えるような複雑な帳票の時に、入力が著しくおそくなる。
 */
var preparePDFOverlayObjects$1 = function (props) {
    return function (currentPageNumber, keyRefreshCount) {
        return formSchema.flatMap(props.allInputs, function (elem) {
            var pdfAdapter = elem.pdfAdapterRule;
            if (!pdfAdapter) {
                return [null];
            }
            var repeatablePair = elem.isExpanded()
                ? {
                    element: elem.parent.repeatable,
                    indexes: {
                        elemIndex: elem.parent.elemIndex,
                        unitIndex: elem.parent.repeatable.baseUnit.findIndex(function (e) { return e.id === elem.id; }),
                    },
                }
                : undefined;
            switch (pdfAdapter.type) {
                case "text":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(TextBox$1, { elem: elem, key: key, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, isRequired: elem.required }));
                    });
                case "text_cell":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(TextCell$1, { elem: elem, key: key, isFocused: false, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, isRequired: elem.required }));
                    });
                case "check":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(Check$1, { elem: elem, key: key, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, isRequired: elem.required }));
                    });
                case "ellipse":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(Ellipse$1, { elem: elem, key: key, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, onDoubleClick: props.onDoubleClick, onObjectEnter: props.onObjectEnter, onObjectLeave: props.onObjectLeave, onResize: props.onResize, isRequired: elem.required }));
                    });
            }
        });
    };
};

var BuilderModePDFRenderingPreview = function (_a) {
    var file = _a.file, pageNumber = _a.pageNumber, keyRefreshCount = _a.keyRefreshCount, options = _a.options, formSchema$1 = _a.formSchema, _b = _a.renderMode, renderMode = _b === void 0 ? "canvas" : _b, _c = _a.errorMessage, errorMessage = _c === void 0 ? "PDFの読み込みに失敗しました。再読み込みしてください。" : _c, _d = _a.onResize, onResize = _d === void 0 ? function () { } : _d, // noop,
    _e = _a.onDoubleClick, // noop,
    onDoubleClick = _e === void 0 ? function () { } : _e, // noop,
    _f = _a.onObjectEnter, // noop,
    onObjectEnter = _f === void 0 ? function () { } : _f, // noop,
    _g = _a.onObjectLeave, // noop,
    onObjectLeave = _g === void 0 ? function () { } : _g, // noop,
    _h = _a.onLoadSuccess, // noop,
    onLoadSuccess = _h === void 0 ? function () { } : _h, //noop
    _j = _a.onLoadError, //noop
    onLoadError = _j === void 0 ? function () { } : _j, //noop
    _k = _a.autoZoom, //noop
    autoZoom = _k === void 0 ? false : _k;
    var fs = formSchema.FormSchema.fromJSON(formSchema$1);
    var allInputs = React.useMemo(function () {
        return fs
            .flattenDeep()
            .filter(function (j) {
            return formSchema.isInputClassElement(j) && !!j.pdfAdapterRule;
        });
    }, [fs]);
    var PDFOverlayObject = React.useMemo(function () {
        return preparePDFOverlayObjects$1({
            allInputs: allInputs,
            onObjectLeave: onObjectLeave,
            onObjectEnter: onObjectEnter,
            onResize: onResize,
            onDoubleClick: onDoubleClick,
        });
    }, [allInputs]);
    return (React__namespace.createElement(PDFDocumentForRenderingPreview, { file: file, options: options, pageNumber: pageNumber, renderMode: renderMode, errorMessage: errorMessage, onLoadSuccess: onLoadSuccess, onLoadError: onLoadError, autoZoom: autoZoom },
        React__namespace.createElement(React__namespace.Fragment, null, PDFOverlayObject(pageNumber, keyRefreshCount || 0))));
};

var PDFRenderingPreview = function (props) {
    switch (props.mode) {
        case "edit":
            return React__namespace.createElement(EditModePDFRenderingPreview, __assign({}, props));
        case "builder":
            return React__namespace.createElement(BuilderModePDFRenderingPreview, __assign({}, props));
        default:
            throw new Error("unexpected mode");
    }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".pdf-document-module_container__bo29l {\n  width: 100%;\n}\n\n.pdf-document-module_pageNumWrapper__e8C24 {\n  display: flex;\n  justify-content: right;\n  margin-bottom: 10px;\n  margin-top: 68px;\n}\n\n.pdf-document-module_documentWrapper__XCFKF {\n  display: flex;\n  justify-content: center;\n}\n\n.pdf-document-module_page__Qo62X {\n  margin-bottom: 30px;\n}\n";
var styles$2 = {"container":"pdf-document-module_container__bo29l","pageNumWrapper":"pdf-document-module_pageNumWrapper__e8C24","documentWrapper":"pdf-document-module_documentWrapper__XCFKF","page":"pdf-document-module_page__Qo62X"};
styleInject(css_248z$2);

// スクロールに合わせてページの番号を変化させるためのhook。
var usePageNumber = function (pageNumber, onCrossLine, parentElement) {
    var currentPageRef = React__default["default"].useRef(null);
    React__default["default"].useEffect(function () {
        var onCross = function (entries) {
            var entry = entries[0];
            if (entry.isIntersecting) {
                onCrossLine(pageNumber);
            }
        };
        var observer = new IntersectionObserver(onCross, {
            root: parentElement,
            rootMargin: "-50% 0px -50% 0px",
        });
        if (currentPageRef.current) {
            observer.observe(currentPageRef.current);
        }
        return function () {
            if (currentPageRef.current) {
                observer.unobserve(currentPageRef.current);
            }
        };
    }, []);
    return {
        currentPageRef: currentPageRef,
    };
};

var PDFPage = function (_a) {
    var pageNumber = _a.pageNumber, renderMode = _a.renderMode, pageRef = _a.pageRef, onCrossPdf = _a.onCrossPdf, keyRefreshCount = _a.keyRefreshCount, PDFOverlayObject = _a.PDFOverlayObject, pageSize = _a.pageSize, onClickPdfPage = _a.onClickPdfPage, parentElement = _a.parentElement;
    var currentPageRef = usePageNumber(pageNumber, onCrossPdf, parentElement).currentPageRef;
    var onClickPage = function (e) {
        if (!currentPageRef.current) {
            return;
        }
        var rect = currentPageRef.current.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var position = { x: x, y: y };
        onClickPdfPage(position, pageNumber);
    };
    return (React__default["default"].createElement("div", { ref: currentPageRef },
        React__default["default"].createElement(reactPdf.Page, { renderMode: renderMode, pageNumber: pageNumber, inputRef: pageRef, className: styles$2.page, onClick: onClickPage },
            React__default["default"].createElement(PDFOverlayLayer, null, PDFOverlayObject(pageNumber, keyRefreshCount, pageSize)))));
};

var usePdfDocument = function (file, autoZoom) {
    var _a = React__default["default"].useState(undefined), totalPages = _a[0], setTotalPages = _a[1];
    var _b = React__default["default"].useState(1), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = React__default["default"].useState(0), pageNumMargin = _c[0], setPageNumMargin = _c[1];
    var _d = React__default["default"].useState([]), pageSizeArray = _d[0], setPageSizeArray = _d[1];
    var containerRef = React__default["default"].useRef(null);
    // 一枚目のPDFの高さと幅を格納したオブジェクト。windowリスナー内で使う変数のためrefにする。
    var firstPdfSizeRef = React__default["default"].useRef(undefined);
    var updatePageNumMargin = function () {
        if (containerRef.current && firstPdfSizeRef.current) {
            var width = containerRef.current.offsetWidth;
            setPageNumMargin((width - firstPdfSizeRef.current.width) / 2);
        }
    };
    var onDocumentLoadSuccess = function (pdfObject) { return __awaiter(void 0, void 0, void 0, function () {
        var pages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(Array.from(new Array(pdfObject.numPages), function (_, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var page, pageSize;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, pdfObject.getPage(index + 1)];
                                case 1:
                                    page = _a.sent();
                                    pageSize = page._pageInfo.view;
                                    return [2 /*return*/, {
                                            width: pageSize[2],
                                            height: pageSize[3],
                                        }];
                            }
                        });
                    }); }))];
                case 1:
                    pages = _a.sent();
                    setPageSizeArray(pages);
                    firstPdfSizeRef.current = pages[0];
                    updatePageNumMargin();
                    setTotalPages(pdfObject.numPages);
                    return [2 /*return*/];
            }
        });
    }); };
    var onCrossPdf = function (pageNumber) {
        setCurrentPage(pageNumber);
    };
    // PDFの倍率変更（画面幅いっぱいに拡大する）
    var autoZoomRef = React.useCallback(function (pageNode) {
        if (!pageNode) {
            return;
        }
        // 適応済みの場合無視する
        // 非標準の属性ではあるが、transform: scale()が挙動が変わるため一旦現状のまま維持する
        // zoom - CSS: カスケーディングスタイルシート | MDN https://developer.mozilla.org/ja/docs/Web/CSS/zoom
        if (pageNode.style.zoom) {
            return;
        }
        var content = pageNode.firstElementChild;
        if (!content) {
            return;
        }
        var ratio = pageNode.clientWidth / content.clientWidth;
        // 同じ倍率なので無視する
        if (ratio === 1) {
            return;
        }
        pageNode.style.zoom = "".concat(ratio * 100, "%");
    }, [file]);
    var pageRef = autoZoom ? autoZoomRef : function () { };
    React__default["default"].useEffect(function () {
        window.addEventListener("resize", updatePageNumMargin);
        return function () {
            window.removeEventListener("resize", updatePageNumMargin);
        };
    }, []);
    return {
        totalPages: totalPages,
        currentPage: currentPage,
        pageNumMargin: pageNumMargin,
        containerRef: containerRef,
        pageSizeArray: pageSizeArray,
        pageRef: pageRef,
        onDocumentLoadSuccess: onDocumentLoadSuccess,
        onCrossPdf: onCrossPdf,
    };
};

/**
 * 特定の要素のviewport内（ブラウザ上で見える範囲）での高さを管理するhook
 * @param targetRef 高さを測りたい要素
 * @param trigger 高さを更新するためのトリガー(optional)。トリガーが更新されたときに高さも更新される。
 * */
var useViewportHeight = function (targetRef, trigger) {
    var _a = React__default["default"].useState("0"), heightInViewport = _a[0], setHeight = _a[1];
    React__default["default"].useEffect(function () {
        if (targetRef.current) {
            var top_1 = targetRef.current.getBoundingClientRect().top;
            setHeight("calc(100vh - ".concat(top_1, "px)"));
        }
    }, [trigger]);
    return {
        heightInViewport: heightInViewport,
    };
};

var PDFDocument = function (_a) {
    var file = _a.file, options = _a.options, renderMode = _a.renderMode, errorMessage = _a.errorMessage, onLoadError = _a.onLoadError, _b = _a.autoZoom, autoZoom = _b === void 0 ? false : _b, keyRefreshCount = _a.keyRefreshCount, PDFOverlayObject = _a.PDFOverlayObject, onClickPdfPage = _a.onClickPdfPage;
    var _c = usePdfDocument(file, autoZoom), currentPage = _c.currentPage, pageNumMargin = _c.pageNumMargin, totalPages = _c.totalPages, onDocumentLoadSuccess = _c.onDocumentLoadSuccess, containerRef = _c.containerRef, pageSizeArray = _c.pageSizeArray, pageRef = _c.pageRef, onCrossPdf = _c.onCrossPdf;
    var scrollbarRef = React__default["default"].useRef(null);
    // scrollbarの高さ。totalPagesが定まった時に高さを計算したいのでtotalPagesをトリガーにする。
    var heightInViewport = useViewportHeight(scrollbarRef, totalPages).heightInViewport;
    return (React__default["default"].createElement("div", { ref: containerRef, className: styles$2.container },
        totalPages && (React__default["default"].createElement("div", { className: styles$2.pageNumWrapper, style: {
                // IE11だとpageNumMarginが0未満になるので対応策として固定値のマージンを設定する
                marginRight: pageNumMargin > 0 ? pageNumMargin : 700,
            } },
            React__default["default"].createElement("span", null,
                currentPage,
                " / ",
                totalPages))),
        React__default["default"].createElement(SimpleBar__default["default"], { style: { height: heightInViewport }, scrollableNodeProps: { ref: scrollbarRef } },
            React__default["default"].createElement("div", { className: styles$2.documentWrapper },
                React__default["default"].createElement(reactPdf.Document, { file: file, error: errorMessage, renderMode: renderMode, 
                    // security issue: isEvalSupported is not defined
                    // add isEvalSupported to options with false value
                    options: __assign(__assign({}, options), { isEvalSupported: false }), onLoadSuccess: onDocumentLoadSuccess, onLoadError: onLoadError }, pageSizeArray.map(function (pageSize, index) { return (React__default["default"].createElement(PDFPage, { key: "pdf_page_".concat(index), pageNumber: index + 1, pageRef: pageRef, renderMode: renderMode, onCrossPdf: onCrossPdf, keyRefreshCount: keyRefreshCount, PDFOverlayObject: PDFOverlayObject, pageSize: { width: pageSize.width, height: pageSize.height }, onClickPdfPage: onClickPdfPage, parentElement: scrollbarRef.current })); }))))));
};

/*
 * オブジェクトがPDFの枠からはみ出ないように調整するための関数
 * @param objectPosition objectのx, y
 * @param objectSize objectのwidthとheight
 * @param pageSize pdf pageのwidthとheight
 * */
var validPosition = function (objectPosition, objectSize, pageSize) {
    var x = objectPosition.x;
    var y = objectPosition.y;
    if (y < 0) {
        y = 0;
    }
    if (y > pageSize.height - objectSize.height) {
        // オブジェクトの位置調整用の変数。これがないとオブジェクトが端にピッタリ合わない。
        // 数字の根拠はなく、位置がちょうどよく見えるマジックナンバー。
        var adjustment = 1;
        y = pageSize.height - objectSize.height - adjustment;
    }
    if (x < 0) {
        x = 0;
    }
    if (x > pageSize.width - objectSize.width) {
        x = pageSize.width - objectSize.width;
    }
    return {
        x: x,
        y: y,
    };
};
/*
 * 2つのFocussedItemInfoが一致しているかどうかを判定する
 */
var isIdentical = function (itemA, itemB) {
    var _a;
    if (itemA.repeatablePair) {
        return (itemA.elem.id === itemB.elem.id &&
            itemA.areaIndex === itemB.areaIndex &&
            itemA.repeatablePair.indexes.unitIndex ===
                ((_a = itemB.repeatablePair) === null || _a === void 0 ? void 0 : _a.indexes.unitIndex) &&
            itemA.repeatablePair.indexes.elemIndex ===
                itemB.repeatablePair.indexes.elemIndex);
    }
    return itemA.elem.id === itemB.elem.id && itemA.areaIndex === itemB.areaIndex;
};
/*
 * Focus対象が存在しているかどうかのチェック
 */
var isFocusTargetExist = function (item) {
    return item.elem.pdfAdapterRule !== undefined &&
        item.elem.pdfAdapterRule.areas[item.areaIndex] !== undefined;
};

var css_248z$1 = ".builder-wrapper-module_builderWrapper__yVnN1 {\n  position: relative;\n}\n\n.builder-wrapper-module_focussed__WV5Rj {\n  border: 2px solid #353ebd;\n}\n\n.builder-wrapper-module_informationBox__Gt9xQ {\n  position: absolute;\n  top: -23px;\n  left: -10px;\n  border-radius: 14px;\n  background-color: #0f1192;\n  color: #fff;\n  padding: 0 6px;\n  height: 20px;\n  white-space: nowrap;\n}\n\n.builder-wrapper-module_delete__pOi4v {\n  width: 80px;\n  border-radius: 2px;\n  background-color: #fff;\n  position: absolute;\n  box-shadow:\n    3px 3px 10px rgba(0, 0, 0, 0.1),\n    -3px 3px 10px rgba(0, 0, 0, 0.1);\n  padding: 2px 0;\n}\n\n.builder-wrapper-module_delete__pOi4v:hover {\n  background-color: #e8e9f9;\n}\n";
var styles$1 = {"builderWrapper":"builder-wrapper-module_builderWrapper__yVnN1","focussed":"builder-wrapper-module_focussed__WV5Rj","informationBox":"builder-wrapper-module_informationBox__Gt9xQ","delete":"builder-wrapper-module_delete__pOi4v"};
styleInject(css_248z$1);

var useDeleteButton = function (deleteMappedInput, elem, areaIndex, repeatable) {
    var _a = React__namespace.useState(false), isDeleteButtonOpen = _a[0], setIsDeleteButtonOpen = _a[1];
    var hideDeleteButton = React__namespace.useCallback(function () {
        setIsDeleteButtonOpen(false);
    }, []);
    var onRightClick = function (e) {
        e.preventDefault();
        setIsDeleteButtonOpen(true);
        // 画面のどこかを押すと削除ボタンを閉じるようにする
        document.addEventListener("click", hideDeleteButton, { once: true });
    };
    var onClickDelete = function () {
        deleteMappedInput({
            id: elem.id,
            elem: elem,
            areaIndex: areaIndex,
            repeatable: repeatable,
        });
    };
    React__namespace.useEffect(function () {
        return function () {
            document.removeEventListener("click", hideDeleteButton);
        };
    }, []);
    return {
        isDeleteButtonOpen: isDeleteButtonOpen,
        onRightClick: onRightClick,
        onClickDelete: onClickDelete,
    };
};

/*
 * objectのフォーカスやobjectがフォーカスされるかどうかの判定に使うhook
 * @param focussedItemInfo 現在フォーカスされるべきアイテムの情報
 * @param objectInfo objectの情報。focussedItemInfoと情報が一致しているか比較される。
 * @param updateFocussedItemInfo focussedItemInfoを更新する関数。
 * */
var useFocusOnObject = function (focussedItemInfo, objectInfo, updateFocussedItemInfo) {
    var getSelectableAreaValue = function (pdfAdaptorRule) {
        return (pdfAdaptorRule &&
            formSchema.isSelectableAdapterRule(pdfAdaptorRule) &&
            pdfAdaptorRule.areas[objectInfo.areaIndex].value);
    };
    var selectableItemName = function (elem) {
        var _a;
        var pdfAdapterRule = elem.pdfAdapterRule, label = elem.label;
        var labelName = label.text;
        var value = getSelectableAreaValue(pdfAdapterRule) || label.text;
        // 一時的にenumから同じvalueをもったアイテムをfindするというスタイルをとるが、
        // これだとenum内のobjectのvalueがユニークではないパターンに対応できない
        // TODO 最終的にはpdfAdaptorRuleの中にインプットのlabelを入れる形にして値を取得する
        var matchedText = (_a = elem.enum.find(function (item) { return value === item.value; })) === null || _a === void 0 ? void 0 : _a.text;
        if (!matchedText) {
            return labelName;
        }
        return "".concat(labelName, " - ").concat(matchedText);
    };
    var itemName = formSchema.isSelectableElement(objectInfo.elem)
        ? selectableItemName(objectInfo.elem)
        : objectInfo.elem.label.text;
    var onClick = function () {
        if (isFocusTargetExist(objectInfo)) {
            updateFocussedItemInfo(objectInfo);
        }
    };
    var isFocussed = React.useMemo(function () {
        if (!focussedItemInfo) {
            return false;
        }
        var thisObject = __assign(__assign({}, objectInfo), { id: objectInfo.elem.id });
        return isIdentical(focussedItemInfo, thisObject);
    }, [focussedItemInfo, objectInfo]);
    return {
        itemName: itemName,
        onClick: onClick,
        isFocussed: isFocussed,
    };
};

var BuilderWrapper = function (_a) {
    var props = __rest(_a, []);
    var size = props.size, position = props.position, style = props.style, elem = props.elem, areaIndex = props.areaIndex, pageNumber = props.pageNumber, onObjectStateChange = props.onObjectStateChange, onDoubleClick = props.onDoubleClick, onObjectEnter = props.onObjectEnter, onObjectLeave = props.onObjectLeave, enableResizable = props.enableResizable, repeatablePair = props.repeatablePair, className = props.className, deleteMappedInput = props.deleteMappedInput, pageSize = props.pageSize, focussedItemInfo = props.focussedItemInfo, updateFocussedItemInfo = props.updateFocussedItemInfo;
    var resizing = enableResizable ? enableResizingAll : disableResizingAll;
    var objectInfo = {
        elem: elem,
        areaIndex: areaIndex,
        repeatablePair: repeatablePair,
    };
    var _b = useFocusOnObject(focussedItemInfo, objectInfo, updateFocussedItemInfo), isFocussed = _b.isFocussed, itemName = _b.itemName, onClick = _b.onClick;
    var _c = React__namespace.useState(size.width), objectWidth = _c[0], setObjectWidth = _c[1];
    var _d = useDeleteButton(deleteMappedInput, elem, areaIndex, repeatablePair), isDeleteButtonOpen = _d.isDeleteButtonOpen, onRightClick = _d.onRightClick, onClickDelete = _d.onClickDelete;
    return (React__namespace.createElement("div", { className: styles$1.builderWrapper, style: {
            // 削除ボタンが他のobjectの後ろに隠れてしまわないようにフォーカス時やボタンを表示しているときだけdivのzIndexを上げる
            zIndex: isDeleteButtonOpen || isFocussed ? 1000 : undefined,
        } },
        React__namespace.createElement(reactRnd.Rnd, { className: "has-text-left ".concat(className, " ").concat(isFocussed && styles$1.focussed), position: {
                x: position.x,
                y: position.y,
            }, size: {
                width: size.width,
                height: size.height,
            }, style: style, onResize: function (e, direction, ref, delta, position) {
                onObjectStateChange({
                    id: elem.id,
                    elem: elem,
                    areaIndex: areaIndex,
                    area: {
                        pageNumber: pageNumber,
                        size: {
                            width: ref.offsetWidth,
                            height: ref.offsetHeight,
                        },
                        position: position,
                    },
                    repeatable: repeatablePair,
                });
                setObjectWidth(ref.offsetWidth);
            }, onDragStop: function (mouseEvent, node) {
                // オブジェクトにクリックしただけで発火してしまうのでオブジェクトの位置が変わっていなければ処理をしないようにする
                if (position.x === node.lastX && position.y === node.lastY) {
                    return;
                }
                onObjectStateChange({
                    id: elem.id,
                    elem: elem,
                    area: {
                        pageNumber: pageNumber,
                        size: size,
                        position: validPosition({ x: node.lastX, y: node.lastY }, size, pageSize),
                    },
                    areaIndex: areaIndex,
                    repeatable: repeatablePair,
                });
            }, onClick: onClick, onContextMenu: onRightClick, onDoubleClick: function () {
                return onDoubleClick({
                    id: elem.id,
                    elem: elem,
                    areaIndex: areaIndex,
                    repeatable: repeatablePair,
                });
            }, onMouseEnter: onObjectEnter, onMouseLeave: onObjectLeave, enableResizing: resizing, disableDragging: false },
            props.renderChild && props.renderChild(props),
            isFocussed && (React__namespace.createElement("div", { className: "".concat(styles$1.informationBox, " gcdk-listBold") },
                React__namespace.createElement("span", null, itemName))),
            isDeleteButtonOpen && (React__namespace.createElement("button", { className: styles$1.delete, style: { left: objectWidth + 10 }, onClick: onClickDelete }, "\u524A\u9664\u3059\u308B")))));
};

var css_248z = ".objects-module_check__ztjQG {\n  text-align: center;\n  font-size: 8px;\n  background-color: rgba(0, 0, 255, 0.1);\n  border-style: none;\n}\n\n.objects-module_ellipse__H2HmZ {\n  text-align: center;\n  border-radius: 50%;\n  background-color: rgba(53, 62, 189, 0.2);\n}\n\n.objects-module_text__9cVLf {\n  background-color: rgba(53, 62, 189, 0.2);\n}\n";
var styles = {"check":"objects-module_check__ztjQG","ellipse":"objects-module_ellipse__H2HmZ","text":"objects-module_text__9cVLf"};
styleInject(css_248z);

var TextBox = React__namespace.memo(function (props) {
    return (React__namespace.createElement(BuilderWrapper, __assign({}, props, { enableResizable: true, className: styles.text })));
});

var TextCell = React__namespace.memo(function (props) {
    return (React__namespace.createElement(BuilderWrapper, __assign({}, props, { enableResizable: true, className: styles.text })));
});

var Check = React__namespace.memo(function (props) {
    return (React__namespace.createElement(BuilderWrapper, __assign({}, props, { className: styles.check, renderChild: function () {
            return React__namespace.createElement(React__namespace.Fragment, null, "\u2714\uFE0E");
        } })));
});

// Maybe we should separate multiple and single select into two objects.
var Ellipse = React__namespace.memo(function (props) {
    return (React__namespace.createElement(BuilderWrapper, __assign({ enableResizable: true, className: styles.ellipse }, props)));
});

/**
 * PDF上にレンダリングするPreview用オブジェクトの作成。
 * 初期化後に変更されえない値と、変更されうる値（documentの値、focusされているFieldのID)を分けて、渡すようにして、不必要な再描画を抑える
 * * これを入れておかないないと、Object数が100を超えるような複雑な帳票の時に、入力が著しくおそくなる。
 */
var preparePDFOverlayObjects = function (_a) {
    var props = __rest(_a, []);
    return function (currentPageNumber, keyRefreshCount, pageSize) {
        return formSchema.flatMap(props.allInputs, function (elem) {
            var pdfAdapter = elem.pdfAdapterRule;
            if (!pdfAdapter) {
                return [null];
            }
            var repeatablePair = elem.isExpanded()
                ? {
                    element: elem.parent.repeatable,
                    indexes: {
                        elemIndex: elem.parent.elemIndex,
                        unitIndex: elem.parent.repeatable.baseUnit.findIndex(function (e) { return e.id === elem.id; }),
                    },
                }
                : undefined;
            switch (pdfAdapter.type) {
                case "text":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(TextBox, __assign({}, props, { elem: elem, key: key, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, isRequired: elem.required, pageSize: pageSize })));
                    });
                case "text_cell":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(TextCell, __assign({}, props, { elem: elem, key: key, isFocused: false, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, isRequired: elem.required, pageSize: pageSize })));
                    });
                case "check":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(Check, __assign({}, props, { elem: elem, key: key, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, isRequired: elem.required, pageSize: pageSize })));
                    });
                case "ellipse":
                    return pdfAdapter.areas.map(function (a, index) {
                        if (a.pageNumber !== currentPageNumber) {
                            return null;
                        }
                        var key = formSchema.ReactKeyUtils.generatePdfAreaKey(elem, index, keyRefreshCount);
                        return (React__namespace.createElement(Ellipse, __assign({}, props, { elem: elem, key: key, areaIndex: index, position: a.position, size: a.size, pageNumber: a.pageNumber, repeatablePair: repeatablePair, isRequired: elem.required, pageSize: pageSize })));
                    });
            }
        });
    };
};

var BuilderModePDFRenderPreview = function (_a) {
    var file = _a.file, keyRefreshCount = _a.keyRefreshCount, options = _a.options, formSchema$1 = _a.formSchema, _b = _a.renderMode, renderMode = _b === void 0 ? "canvas" : _b, _c = _a.errorMessage, errorMessage = _c === void 0 ? "PDFの読み込みに失敗しました。再読み込みしてください。" : _c, _d = _a.onObjectStateChange, onObjectStateChange = _d === void 0 ? function () { } : _d, // noop,
    _e = _a.onDoubleClick, // noop,
    onDoubleClick = _e === void 0 ? function () { } : _e, // noop,
    _f = _a.onObjectEnter, // noop,
    onObjectEnter = _f === void 0 ? function () { } : _f, // noop,
    _g = _a.onObjectLeave, // noop,
    onObjectLeave = _g === void 0 ? function () { } : _g, // noop,
    _h = _a.onLoadError, // noop,
    onLoadError = _h === void 0 ? function () { } : _h, // noop
    _j = _a.autoZoom, // noop
    autoZoom = _j === void 0 ? false : _j, _k = _a.deleteMappedInput, deleteMappedInput = _k === void 0 ? function () { } : _k, // noop
    onClickPdfPage = _a.onClickPdfPage, _l = _a.focussedItemInfo, focussedItemInfo = _l === void 0 ? null : _l, _m = _a.updateFocussedItemInfo, updateFocussedItemInfo = _m === void 0 ? function () { return null; } : _m;
    var fs = formSchema.FormSchema.fromJSON(formSchema$1);
    var allInputs = React.useMemo(function () {
        return fs
            .flattenDeep()
            .filter(function (j) {
            return formSchema.isInputClassElement(j) && !!j.pdfAdapterRule;
        });
    }, [fs]);
    var PDFOverlayObject = React.useMemo(function () {
        return preparePDFOverlayObjects({
            allInputs: allInputs,
            onObjectLeave: onObjectLeave,
            onObjectEnter: onObjectEnter,
            onObjectStateChange: onObjectStateChange,
            onDoubleClick: onDoubleClick,
            deleteMappedInput: deleteMappedInput,
            focussedItemInfo: focussedItemInfo,
            updateFocussedItemInfo: updateFocussedItemInfo,
        });
    }, [allInputs]);
    return (React__namespace.createElement(PDFDocument, { file: file, options: options, renderMode: renderMode, errorMessage: errorMessage, onLoadError: onLoadError, autoZoom: autoZoom, keyRefreshCount: keyRefreshCount || 0, PDFOverlayObject: PDFOverlayObject, onClickPdfPage: onClickPdfPage }));
};

var PDFRenderPreview = function (props) {
    switch (props.mode) {
        case "edit":
            return React__namespace.createElement(EditModePDFRenderingPreview, __assign({}, props));
        case "builder":
            return React__namespace.createElement(BuilderModePDFRenderPreview, __assign({}, props));
        default:
            throw new Error("unexpected mode");
    }
};

exports.PDFRenderPreview = PDFRenderPreview;
exports.PDFRenderingPreview = PDFRenderingPreview;
exports.isIdentical = isIdentical;
exports.useDeleteButton = useDeleteButton;
exports.useViewportHeight = useViewportHeight;
